import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Injector,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { EditPanelComponent } from '@Work/Accounts/proprietary/controls/form-controls/edit-panel/edit-panel.component';
import { DocumentDistributeObjectService } from '@Core/models/proprietary/document-distribute/document-distribute-object.service';
import { DocumentDistributeObjectState } from '@Core/models/proprietary/document-distribute/document-distribute-object.state';

@Component({
    standalone: false,
    selector: 'ep-document-distribute-filing-edit-panel',
    templateUrl: './document-distribute-filing-edit-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentDistributeFilingEditPanelComponent extends EditPanelComponent implements OnInit, OnDestroy {
    @Input()
    set filing(value: any) {
        this.setFormData(value);
    }

    @Input()
    parentDocID;

    distMethodByDocID$: Observable<any>;
    parentDistMethodSub: Subscription;
    parentDistMethod: string = 'Q';

    constructor(
        private injector: Injector,
        private cdRef: ChangeDetectorRef,
        public documentDistributeOS: DocumentDistributeObjectService
    ) {
        super(injector);

        this.form = new UntypedFormGroup(
            {
                Filing: this.fb.group({
                    DocLink_ID: [''],
                    Distribute: this.fb.group({
                        Method: ['']
                    }),
                    Book: this.fb.group({
                        Entity_ID: ['']
                    }),
                    Book_Loc: this.fb.group({
                        Entity_ID: ['']
                    }),
                    Entity: this.fb.group({
                        Entity_ID: [''],
                        Role_Type: [''],
                        Entity_Name: ['']
                    }),
                    Affiliate: this.fb.group({
                        Entity_ID: [''],
                        Entity_Name: ['']
                    }),
                    File_Only_Ind: [''],
                    File_External_Ind: [''],
                    Public_Document_Ind: [''],
                    Contract: this.fb.group({
                        Contract_ID: ['']
                    }),
                    File_Drawer: [''],
                    File_Folder: ['']
                })
            },
            { updateOn: 'blur' }
        );
    }

    ngOnInit() {
        this.ignorePageState = true;

        super.ngOnInit();
        this.formChangeSub = this.form.valueChanges.subscribe((value) => {
            this.documentDistributeOS.updateFiling(this.form.getRawValue().Filing);
        });
        this.distMethodByDocID$ = this.store.select(DocumentDistributeObjectState.distMethodByDocID(this.parentDocID));
        this.parentDistMethodSub = this.distMethodByDocID$.subscribe((method) => {
            this.parentDistMethod = method;
            this.applyRules();
        });
    }

    applyRules() {
        this.disableControl('Filing.Entity', true);
        this.disableControl('Filing.File_Only_Ind', this.parentDistMethod == 'F' || this.parentDistMethod == 'P');
    }

    setFormData(value: any) {
        if (value) {
            this.form.controls.Filing.patchValue(value, { emitEvent: false });
            this.cdRef.detectChanges();
            this.applyRules();
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.parentDistMethodSub) {
            this.parentDistMethodSub.unsubscribe();
        }
    }

    removeFiling() {
        this.documentDistributeOS.removeFiling(this.parentDocID, this.form.getRawValue().Filing.DocLink_ID);
    }

    onAffiliateSelected(data: any) {
        this.documentDistributeOS.updateFiling(this.form.getRawValue().Filing);
    }
}
